<template>
  <b-list-group id="list-dnt">
    <TraysFilters
      class="d-none"
      :value="filters"
      :onChange="onChangeFilters"
      :clear="clearFilters"
    />
    <b-list-group-item
      class="flex-column align-items-start bg-white mt-2"
      :key="file.aprobacionId"
      v-for="file in orderTrays"
      :file="file"
      @click="selectFile(file)">
      <div class="row">
        <div class="col-3 text-center text-primary">
          <div class="d-flex justify-content-center">
            <span v-if="file.app === 'FEB'" v-tooltip="'Flujo de Febos'">
              <vs-chip
                color="warning"
                :class="{ 'text-success': wasCopied }"
                class="cursor-pointer mr-2"
                @click.native="copyToClipboard(file.id, file.numero)"
              >
                {{file.numero}}
              </vs-chip>
            </span>
            <span
              v-if="file.app === 'ED' && file.tipoObjetoId === 'ARCHIVO-RP'"
              v-tooltip="'Repositorio'"
            >
              <vs-chip
                color="primary"
                :class="{ 'text-success': wasCopied }"
                class="cursor-pointer mr-2"
                @click.native="copyToClipboard(file.id, file.numero)"
              >
                <vs-avatar color="primary" text="R"/>
                {{file.numero}}
              </vs-chip>
            </span>
            <span
              v-if="file.app === 'ED' && file.tipoObjetoId === 'EXP'"
              v-tooltip="'Expediente'"
            >
              <vs-chip
                color="primary"
                :class="{ 'text-success': wasCopied }"
                class="cursor-pointer mr-2"
                @click.native="copyToClipboard(file.id, file.numero)"
              >
                <vs-avatar color="primary"  text="E"/>
                {{file.numero}}
              </vs-chip>
            </span>
            <span
              v-if="file.app === 'ED' && file.tipoObjetoId === 'ARCHIVO'"
              v-tooltip="'Archivo'"
            >
              <vs-chip
                color="primary"
                :class="{ 'text-success': wasCopied }"
                class="cursor-pointer mr-2"
                @click.native="copyToClipboard(file.id, file.numero)"
              >
                <vs-avatar color="primary"  text="A"/>
                {{file.numero}}
              </vs-chip>
            </span>
          </div>
        </div>
        <div class="col-9">
          {{ file.nombre }}
          <div v-tooltip="`${file.descripcion}`">
            <small class="text-primary">
              {{file.descripcion | truncate(40)}}
            </small>
          </div>
        </div>
        <div class="col-6">
          {{ file.autor }}
        </div>
        <div class="col-6">
          <vs-chip
            v-if="file.aprobacionesEjecucionEstadoId.toString()
             === FileStates.INITIATED"
            title="Iniciado"
          >
            <vs-avatar icon="query_builder" color="#43C3B9" />
            Iniciado
          </vs-chip>
          <vs-chip
            title="Pendiente"
            v-if="file.aprobacionesEjecucionEstadoId.toString()
             === FileStates.PREPARED"
          >
            <vs-avatar icon="language" color="#adadad" />
            Preparado
          </vs-chip>
          <vs-chip
            title="Aprobado"
            v-if="file.aprobacionesEjecucionEstadoId.toString()
             === FileStates.APPROVED"
          >
            <vs-avatar icon="thumb_up" color="#28c76f" />
            Aprobado
          </vs-chip>
          <vs-chip
            title="Rechazado"
            v-if="file.aprobacionesEjecucionEstadoId.toString()
             === FileStates.REJECTED"
          >
            <vs-avatar icon="thumb_down" color="#ea5455" />
            Rechazado
          </vs-chip>
          <vs-chip
            title="Retornado"
            v-if="file.aprobacionesEjecucionEstadoId.toString()
             === FileStates.CANCELED"
          >
            <vs-avatar icon="block" color="#bf0303" />
            Anulado
          </vs-chip>
          <vs-chip
            title="Desestimado"
            v-if="file.aprobacionesEjecucionEstadoId.toString()
             === FileStates.DISMISSED"
          >
            <vs-avatar icon="save_alt" color="#848484" />
            Desestimado
          </vs-chip>
        </div>
      </div>
      <div class="row">
        <div class="col-12 pt-2 border-top">
          <vs-chip class="mr-4" v-tooltip="'Fecha inicio del proceso'">
            <vs-avatar icon="date_range" />
            inicio {{file.fechaInicioProceso | dateFormat }}
          </vs-chip>
          <vs-chip
            class="mr-4"
            v-tooltip="'Proceso de pasos'"
            color="primary" transparent
          >
            <vs-avatar icon="group" />
            paso {{file.numeroPaso}} de {{file.totalPasos}}
          </vs-chip>
          <vs-chip
            v-tooltip="'Nombre de documento en flujo'"
            color="warning" transparent
            class="mr-4"
          >
            <vs-avatar icon="description" />
            {{file.objetoNombre | truncate(20)}}
          </vs-chip>
          <vs-chip
            v-if="file.privado === 'Y'"
            v-tooltip="'Privado'"
            color="primary" transparent
            class="mr-4"
          >
            <vs-avatar icon="lock" />
            privado
          </vs-chip>
          <vs-chip
            v-if="file.folio"
            v-tooltip="'Número de documento'"
            color="warning" transparent
            class="mr-4"
          >
            <vs-avatar icon="description" />
            {{file.folio}}
          </vs-chip>
          <vs-chip
            v-if="file.foliado"
            v-tooltip="'Fecha de documento'"
            color="warning" transparent
            class="mr-4"
          >
            <vs-avatar icon="date_range" />
            {{file.foliado | dateFormat}}
          </vs-chip>
          <vs-chip
            v-if="file.tipoObjetoCategoria"
            v-tooltip="'Tipo de documento'"
            color="warning" transparent
            class="mr-4"
          >
            <vs-avatar icon="description" />
            {{file.tipoObjetoCategoria | truncate(20)}}
          </vs-chip>
          <vs-chip
            v-if="file.oficinaNombre"
            v-tooltip="'Oficina que numeró o tramitó'"
            color="warning" transparent
            class="mr-4"
          >
            <vs-avatar icon="apartment" />
            {{file.oficinaNombre}}
          </vs-chip>
          <vs-chip
            v-if="file.app === 'FEB'"
            v-tooltip="'Tipo de documento en flujo'"
            color="warning" transparent
            class="mr-4"
          >
            <vs-avatar icon="description" />
            {{findTypeDocument(file.tipoReferencia)}}
          </vs-chip>
        </div>
      </div>
    </b-list-group-item>
    <FilesPagination
      :show="trays.length"
      v-model="page"
    />
  </b-list-group>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import FilesPagination from '@/febos/chile/approvals/components/trays/FilesPagination';
import { removeSearchParams, updateSearchParams } from '@/febos/global/utils/router';
import { mergeFilters } from '@/febos/chile/dnt/utils/fitlers';
import FileStates from '@/febos/chile/approvals/mixins/FileStates';
import CopyToClipboard from '@/febos/chile/approvals/mixins/CopyToClipboard';
import TraysFilters from '@/febos/chile/approvals/components/trays/TraysFilters';

export default {
  name: 'Trays',
  components: { FilesPagination, TraysFilters },
  mixins: [FileStates, CopyToClipboard],
  data() {
    console.log('WERW', this.$route.params.view);
    return {
      view: this.$route.params.view,
      FileStates,
      selectedFile: {},
      filters: '',
      page: Number.parseInt(this.$route.query.page || 1, 10),
      paginate: Number.parseInt(this.$route.query.paginate || 20, 10),
      forceRender: Date.now(), // TODO: the files watch
      // is triggered but the component not re-render.
      types: {
        0: 'Otros',
        30: 'Factura',
        32: 'Factura Exenta',
        33: 'Factura Afecta Electrónica',
        34: 'Factura Exenta Electrónica',
        35: 'Boleta',
        38: 'Boleta Exenta',
        39: 'Boleta Afecta Electrónica',
        41: 'Boleta Exenta Electrónica',
        45: 'Factura de Compra',
        46: 'Factura Electrónica de Compra',
        43: 'Liquidación de Factura',
        50: 'Guía de Despacho',
        60: 'Nota de Crédito',
        55: 'Nota de Débito',
        52: 'Guía de Despacho Electrónica',
        56: 'Nota de Débito Electrónica',
        61: 'Nota de Crédito Electrónica',
        99: 'Anticipos y otras Transacciones',
        110: 'Factura de Exportación Electrónica',
        111: 'Nota de Débito de Exportación Electrónica',
        112: 'Nota de Crédito de Exportación Electrónica',
        801: 'Orden de Compra',
        802: 'Nota de Pedido',
        803: 'Contrato',
        804: 'Resolución',
        805: 'Proceso Chile Compra',
        806: 'Ficha Chile Compra',
        807: 'DUS',
        808: 'B/L Conocimiento de Embarque',
        809: 'AWB',
        810: 'MIC/DATA',
        811: 'Carta de Porte',
        812: 'Res. SNA Servicio Exportación',
        813: 'Pasaporte',
        814: 'Cert. Depósito BP',
        815: 'Vale Prenda BP',
        RD1: 'Rendicion de Financiamiento',
        RD2: 'Rendicion de Gastos',
        HES: 'HES - Hoja Entrada Servicio',
        HEM: 'HEM - Hoja Entrada Mercaderia',
        SCO: 'SCO - Solicitud de Compra',
        MP: 'Orden de Compra MP',
        NV: 'Nota de Venta',
        FIN: 'Factura Interna',
        LIC: 'Licitación',
        BGT: 'Boleta',
        BG: 'Boleta de Garantía',
        BTG: 'Boleta de Garantía',
        PZ: 'Póliza',
        SWF: 'Swift',
        PGR: 'Pagare',
        VLV: 'Vale Vista',
        CHI: 'Cheque Internacional',
        CHN: 'Cheque Nacional',
        EPG: 'Estado de Pago',
        PRY: 'Proyecto',
        CFZ: 'Certificado de Fianza',
        ARCHIVO: 'Archivo',
        NPP: 'Nómina Pronto Pago',
        APR: 'Acta de Aprobación',
        ACRE: 'Expediente',
        MEMO: 'Memorándum',
        DTE: 'Documento Tributario',
        DNT: 'Documento no Tributario',
        EXP: 'Expediente',
        SSD: 'Proceso SSD',
        DDD: 'DocDigital',
        ALI: 'Antecedentes Licitación',
        BIM: 'Banco de Imágenes',
        BOL: 'Boletas',
        CERT: 'Certificado'
      }
    };
  },
  watch: {
    trays() {
      this.forceRender = Date.now(); // TODO: remove this.
    },
    async page(page) {
      updateSearchParams({ page });
      await this.fetchTrays();
    },
    loading(value) {
      if (!value) {
        this.$vs.loading.close('#list-dnt > .con-vs-loading');
        return;
      }

      this.$vs.loading({
        container: '#list-dnt',
        scale: 0.6
      });
    },
    error(error) {
      if (error !== '') {
        this.$vs.notify({
          title: 'Oops!',
          text: error,
          color: 'danger',
          time: 10000,
          position: 'top-center'
        });
        this.clearErrorMessage();
      }
    }
  },
  computed: {
    ...mapGetters('Approvals', [
      'loading',
      'error',
      'trays',
      'documentTypeReferences'
    ]),
    ...mapGetters('Empresas', [
      'company'
    ]),
    ...mapGetters('Usuario', [
      'currentUser'
    ]),
    orderTrays() {
      if (this.view === 'pre-oficina' && this.trays.length) {
        return [...this.trays]
          .sort((a, b) => (a.aprobacionesPasoEstadoId.toString())
            .localeCompare((b.aprobacionesPasoEstadoId.toString())));
      }
      return this.trays;
    }
  },
  methods: {
    ...mapActions('Approvals', [
      'listTrays',
      'clearErrorMessage',
      'selectFileState',
      'getApprovalManagedFile',
      'fetchDocumentTypeReferences'
    ]),
    ...mapActions('Modals', [
      'closeModal'
    ]),
    ...mapActions('Empresas', [
      'getUserSigns'
    ]),
    selectFile(file) {
      this.selectedFile = file;
      this.selectFileState(file.idAprobacion);
      if (this.view === 'entrada-movil') {
        this.$router.push({
          name: 'mobile-manage',
          params: {
            fileId: file.aprobacionesReferenciaId,
            flowId: file.idAprobacion
          }
        });
      } else {
        this.getApprovalManagedFile({
          aprobacionId: file.aprobacionesReferenciaId,
          ejecucionId: file.idAprobacion
        });
      }
    },
    findTypeDocument(typeDocument) {
      const typesArray = Object.keys(this.types)
        .map((type) => ({ valor: type, descripcion: this.types[type] }));
      const documents = typesArray.concat(this.documentTypeReferences);
      const typeDoc = documents.find((doc) => doc.valor === typeDocument);
      return typeDoc ? typeDoc.descripcion : '-';
    },
    fetchTrays() {
      const query = {
        filtros: mergeFilters(this.filters, this.$route.query.filters),
        pagina: this.page,
        orden: '-fechaCreacion',
        elementosPorPagina: this.paginate
      };
      this.listTrays(query);
    },
    async onChangeFilters(filters, onMounted) {
      this.filters = filters;
      if (!onMounted) {
        if (this.page !== 1) {
          this.page = 1;
          // using else because this method has two responsibilities
        } else {
          // force fetch (if we change the page from 1 to 1 the watcher not run)
          await this.fetchTrays();
        }
      }
    },
    clearFilters() {
      removeSearchParams(['filters']);
      // TODO: try to change to default filter state for current view.
      updateSearchParams({ page: 1 });
      this.$router.go();
    }
  },
  created() {
    this.closeModal();
    this.getUserSigns(this.company.iut);
    this.selectFileState('');
    this.fetchDocumentTypeReferences();
  },
  mounted() {
    this.fetchTrays();
  }
};
</script>
